"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastNotification = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../Button");
var _Icons = require("../Icons");
var Toast = _interopRequireWildcard(require("@radix-ui/react-toast"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ToastNotificationModule = _interopRequireDefault(require("./ToastNotification.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ToastRoot = _ToastNotificationModule.default.ToastRoot,
  ToastIcon = _ToastNotificationModule.default.ToastIcon,
  TextWrapper = _ToastNotificationModule.default.TextWrapper,
  ToastTitle = _ToastNotificationModule.default.ToastTitle,
  ToastDescription = _ToastNotificationModule.default.ToastDescription,
  ToastButton = _ToastNotificationModule.default.ToastButton,
  ToastClose = _ToastNotificationModule.default.ToastClose,
  ToastViewport = _ToastNotificationModule.default.ToastViewport;
var ToastNotification = _ref => {
  var viewportClassName = _ref.viewportClassName,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 10000 : _ref$duration,
    title = _ref.title,
    description = _ref.description,
    actionTitle = _ref.actionTitle,
    _ref$actionAltText = _ref.actionAltText,
    actionAltText = _ref$actionAltText === void 0 ? 'call to action' : _ref$actionAltText,
    _ref$positionVariant = _ref.positionVariant,
    positionVariant = _ref$positionVariant === void 0 ? 'right' : _ref$positionVariant,
    _ref$themeVariant = _ref.themeVariant,
    themeVariant = _ref$themeVariant === void 0 ? 'primary' : _ref$themeVariant,
    _ref$swipeDirection = _ref.swipeDirection,
    swipeDirection = _ref$swipeDirection === void 0 ? 'left' : _ref$swipeDirection,
    _ref$openToast = _ref.openToast,
    openToast = _ref$openToast === void 0 ? false : _ref$openToast,
    onClick = _ref.onClick,
    onClose = _ref.onClose;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var buttonVariant = themeVariant === 'error' ? _Button.Color.Red : _Button.Color.Highlight;
  var handleOnClose = (0, _react.useCallback)(() => {
    setOpen(false);
    onClose && onClose();
  }, [onClose]);
  (0, _react.useEffect)(() => {
    setOpen(openToast);
  }, [openToast]);
  return /*#__PURE__*/_react.default.createElement(Toast.Provider, {
    swipeDirection: swipeDirection
  }, /*#__PURE__*/_react.default.createElement(Toast.Root, {
    "data-testid": "toast-root",
    className: ToastRoot,
    "data-variant": themeVariant,
    "data-position": positionVariant,
    open: open,
    onOpenChange: handleOnClose,
    duration: duration
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ToastIcon
  }, /*#__PURE__*/_react.default.createElement(_Icons.IconInfoCircle, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: TextWrapper
  }, /*#__PURE__*/_react.default.createElement(Toast.Title, {
    className: ToastTitle
  }, title), /*#__PURE__*/_react.default.createElement(Toast.Description, {
    className: ToastDescription
  }, description)), actionTitle && /*#__PURE__*/_react.default.createElement(Toast.Action, {
    onClick: onClick,
    asChild: true,
    altText: actionAltText
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: ToastButton,
    color: buttonVariant
  }, actionTitle)), /*#__PURE__*/_react.default.createElement(Toast.Close, {
    className: ToastClose,
    "data-no-action-button": !actionTitle,
    asChild: true,
    "data-testid": "toast-close-button"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleOnClose
  }, /*#__PURE__*/_react.default.createElement(_Icons.IconXClose, {
    size: 24
  })))), /*#__PURE__*/_react.default.createElement(Toast.Viewport, {
    "data-testid": "toast-viewport",
    className: (0, _classnames.default)(ToastViewport, viewportClassName),
    "data-variant": positionVariant
  }));
};
exports.ToastNotification = ToastNotification;
//# sourceMappingURL=ToastNotification.js.map